<app-auth-shell>
  @switch (state) {
    @case ('checking') {
      <div class="af-center" role="status">
        <span class="af-badge"><span class="af-spinner" aria-hidden="true"></span></span>
        <div class="af-head"><h1>One moment…</h1><p>Checking your reset link.</p></div>
      </div>
    }

    @case ('invalid') {
      <div class="af-center">
        <span class="af-badge af-badge--danger" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>
        </span>
        <div class="af-head">
          <h1>Link expired</h1>
          <p>This reset link has expired or was already used. Reset links work once, for 1 hour.</p>
        </div>
        <div class="af-stack">
          <a class="af-btn af-btn--primary" routerLink="/forgot-password">Send a new link</a>
          <a class="af-link" routerLink="/login">Back to sign in</a>
        </div>
      </div>
    }

    @default {
      <div class="af-head">
        <h1>Choose a new password</h1>
        @if (email) {
          <p>For <strong>{{ email }}</strong>. You'll be signed out on your other devices.</p>
        }
      </div>

      @if (error) {
        <div class="af-alert af-alert--error" role="alert"><p>{{ error }}</p></div>
      }

      <form class="af-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <input type="email" class="visually-hidden" [value]="email" autocomplete="username" tabindex="-1" aria-hidden="true" readonly />
        <app-password-field [control]="form.controls.password" label="New password" inputId="rp-password"
          autocomplete="new-password" [showStrength]="true" [serverError]="passwordError"></app-password-field>
        <app-password-field [control]="form.controls.confirm" label="Confirm new password" inputId="rp-confirm"
          autocomplete="new-password"></app-password-field>
        @if (form.controls.confirm.errors?.['mismatch'] && form.controls.confirm.touched) {
          <p class="af-error af-mismatch">The passwords don't match.</p>
        }
        <button type="submit" class="af-btn af-btn--primary" [disabled]="busy">
          @if (busy) { <span class="af-spinner" aria-hidden="true"></span> Saving… } @else { Save and sign in }
        </button>
      </form>
    }
  }
</app-auth-shell>
